import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitogoacab() {



const cardData = {
  keyword: " Mumbai to Goa Cabs",

headingDescription: "Velocity Cab provides reliable and comfortable Mumbai to Goa Cabs services, ensuring a smooth and stress‑free journey to one of Maharashtra’s most revered Shiva pilgrimage sites and scenic hill stations. Our professional drivers, well‑maintained vehicles, and punctual pickups make traveling from Mumbai to Bhimashankar convenient and enjoyable. We offer flexible booking options including one‑way trips, round trips, and customized travel plans with transparent pricing and no hidden charges. Our fleet includes air‑conditioned sedans, spacious SUVs, and luxury cars suitable for solo travelers, families, and groups. With easy online booking and 24/7 customer support, Velocity Cab is the trusted choice for your Mumbai to Bhimashankar cab travel.",

topPlaces: [
  {
    title: "Calangute Beach",
    description: "Calangute Beach is Goa's largest and most popular beach, famous for its golden sands, vibrant nightlife, water sports, beach shacks, and lively atmosphere. It is a perfect destination for families, couples, and adventure seekers."
  },
  {
    title: "Baga Beach",
    description: "Baga Beach is a lively coastal destination known for its exciting water activities, beach clubs, seafood restaurants, and energetic nightlife. Visitors can enjoy parasailing, jet skiing, and stunning sunset views."
  },
  {
    title: "Dudhsagar Waterfalls",
    description: "Dudhsagar Waterfalls is one of India's tallest waterfalls, surrounded by lush forests and the Western Ghats. Travelers can experience scenic jeep safaris, trekking trails, and breathtaking natural beauty."
  },
  {
    title: "Fort Aguada",
    description: "Fort Aguada is a well-preserved 17th-century Portuguese fort offering panoramic views of the Arabian Sea. It is a popular attraction for history lovers, photographers, and sunset enthusiasts."
  },
  {
    title: "Basilica of Bom Jesus",
    description: "The Basilica of Bom Jesus is a UNESCO World Heritage Site renowned for its magnificent Baroque architecture and the sacred relics of St. Francis Xavier. It is one of Goa's most iconic historical landmarks."
  },
  {
    title: "Anjuna Beach",
    description: "Anjuna Beach is famous for its rocky shoreline, flea market, beach parties, and vibrant nightlife. It attracts backpackers, couples, and travelers seeking a relaxed yet energetic beach experience."
  },
  {
    title: "Palolem Beach",
    description: "Palolem Beach is a picturesque crescent-shaped beach known for its calm waters, swaying palm trees, kayaking, and peaceful ambiance. It is an ideal destination for relaxation and nature lovers."
  },
  {
    title: "Chapora Fort",
    description: "Chapora Fort is a historic hilltop fort offering spectacular views of the Arabian Sea and Vagator Beach. It is a favorite spot for sightseeing, photography, and watching mesmerizing sunsets."
  },
  {
    title: "Colva Beach",
    description: "Colva Beach is one of South Goa's most popular beaches, known for its white sands, coconut groves, water sports, and tranquil atmosphere. It is perfect for leisurely walks and seaside relaxation."
  },
  {
    title: "Spice Plantations",
    description: "Goa's spice plantations offer guided tours through lush gardens filled with aromatic spices, tropical fruits, and traditional Goan cuisine. Visitors can enjoy a unique blend of nature, culture, and local flavors."
  }
],



 "services": [
    {
      "name": "Mumbai to Goa Cab Service",
      "description": "Mumbai to Goa cab service offers a comfortable and scenic journey along one of India's most beautiful coastal routes. This service is ideal for families, couples, solo travelers, and groups planning a relaxing vacation or business trip. Professional drivers ensure a safe and smooth ride throughout the journey. Customers can choose from sedan, SUV, and premium vehicles based on their travel needs and group size. Flexible pickup options from home, airport, or railway station make travel convenient. With transparent pricing, easy booking, and 24x7 availability, this cab service ensures a hassle-free travel experience."
    },
    {
      "name": "Mumbai to Goa Taxi",
      "description": "Mumbai to Goa taxi service provides reliable and comfortable transportation for leisure trips, family vacations, and business travel. Well-maintained vehicles and experienced drivers ensure a safe and enjoyable journey. This service is suitable for one way as well as round trips. Travelers can enjoy door-to-door pickup and flexible travel timings. Multiple vehicle options are available for different budgets and group sizes. With affordable pricing and easy booking, this taxi service ensures a smooth and pleasant journey."
    },
    {
      "name": "One Way Cab Mumbai to Goa",
      "description": "One way cab Mumbai to Goa is a cost-effective option for travelers who need a single-side drop without paying return charges. This service is perfect for vacationers, students, and business travelers. Customers benefit from competitive pricing, flexible pickup timing, and comfortable vehicles. Professional drivers ensure timely arrival and safe driving throughout the route. Sedan and SUV options are available based on travel needs. Easy online booking and instant confirmation make it convenient for all travelers."
    },
    {
      "name": "Mumbai to Goa Cab Booking",
      "description": "Mumbai to Goa cab booking allows travelers to reserve their cab quickly with instant confirmation and flexible scheduling. Customers can choose vehicle types, travel dates, and pickup locations according to their preferences. Transparent pricing ensures no hidden costs during the journey. Online booking options make the process simple and convenient. Dedicated customer support is available before and during the trip. It is the easiest way to plan your Goa journey."
    },
    {
      "name": "Mumbai to Goa Outstation Taxi",
      "description": "Mumbai to Goa outstation taxi service offers comfortable long-distance travel with reliable vehicles and experienced drivers. This service is designed for tourists, families, and business travelers seeking a smooth and safe journey. Flexible pickup points and multiple travel options add convenience. Travelers can choose between one way and round trip packages. Vehicles are well-maintained for comfort and safety throughout the route. This service ensures a relaxed and enjoyable travel experience."
    },
    {
      "name": "Cheap Cab Mumbai to Goa",
      "description": "Cheap cab Mumbai to Goa provides budget-friendly travel options without compromising comfort and safety. This service is ideal for cost-conscious travelers looking for reliable transportation. Economical sedan options are available for lower fares. Transparent pricing ensures no hidden charges. Professional drivers ensure safe and comfortable travel throughout the journey. It is a perfect balance of affordability and convenience."
    },
    {
      "name": "Mumbai to Goa Tour Cab",
      "description": "Mumbai to Goa tour cab service is specially designed for travelers planning holidays, sightseeing, and beach vacations. This service ensures comfortable travel with flexible stops for meals, photography, and sightseeing along the route. Experienced drivers are familiar with the best travel routes and tourist destinations. Flexible itineraries allow travelers to enjoy their journey at their own pace. It is suitable for families, couples, and groups. This service ensures a memorable and relaxing travel experience."
    },
    {
      "name": "Private Taxi Mumbai to Goa",
      "description": "Private taxi Mumbai to Goa offers a personalized travel experience with exclusive vehicle usage. Travelers can customize their route, sightseeing stops, and travel schedule according to their preferences. This ensures a comfortable and stress-free journey. Professional drivers provide reliable service throughout the trip. Comfortable seating and clean vehicles enhance the travel experience. It is ideal for families, couples, and private groups."
    },
    {
      "name": "AC Cab Mumbai to Goa",
      "description": "AC cab Mumbai to Goa ensures a comfortable journey in air-conditioned vehicles, making long-distance travel pleasant in every season. This service provides a relaxing environment throughout the trip. Clean interiors and well-maintained AC systems enhance passenger comfort. Suitable for families, tourists, and corporate travelers. Flexible pickup options add convenience. It ensures a refreshing and enjoyable travel experience."
    },
    {
      "name": "Mumbai to Goa SUV Taxi",
      "description": "Mumbai to Goa SUV taxi is ideal for group travel and those seeking extra comfort on long-distance journeys. SUVs provide spacious seating, ample luggage space, and a comfortable ride for families and friends. Professional drivers ensure safe and smooth travel throughout the route. It offers a premium travel experience with added convenience. Ideal for vacations, road trips, and business travel."
    },
    {
      "name": "Mumbai to Goa Cab Fare",
      "description": "Mumbai to Goa cab fare offers transparent and competitive pricing based on distance, vehicle type, and travel duration. Customers receive clear fare details including tolls and driver allowances where applicable. This helps travelers plan their travel budget effectively. Affordable options are available for sedan, SUV, and premium vehicles. No hidden charges ensure trust and reliability. It provides excellent value for money for a comfortable Goa journey."
    }
  ],
  "tableData": [
    ["Mumbai to Goa Cab Service", "Mumbai to Goa Taxi"],
    ["One Way Cab Mumbai to Goa", "Mumbai to Goa Cab Booking"],
    ["Mumbai to Goa Outstation Taxi", "Cheap Cab Mumbai to Goa"],
    ["Mumbai to Goa Tour Cab", "Private Taxi Mumbai to Goa"],
    ["AC Cab Mumbai to Goa", "Mumbai to Goa SUV Taxi"],
    ["Mumbai to Goa Cab Fare", "Mumbai to Goa Cab Service"]
  ],



whychoose: [
  {
    WhyChooseheading: "Comfortable Goa Road Trip",
    WhyChoosedescription: "Velocity Cabs offers Mumbai to Goa cab packages designed for a relaxing and enjoyable road trip, making your journey as memorable as your destination."
  },
  {
    WhyChooseheading: "Experienced Highway Drivers",
    WhyChoosedescription: "Our professional drivers are highly experienced on the Mumbai to Goa route, ensuring safe driving, smooth navigation, and timely arrival."
  },
  {
    WhyChooseheading: "Transparent Cab Pricing",
    WhyChoosedescription: "Velocity Cabs offers clear and transparent pricing for Mumbai to Goa cab bookings. Customers receive complete fare details, including toll charges and driver allowance, with no hidden costs."
  },
  {
    WhyChooseheading: "24/7 Cab Availability",
    WhyChoosedescription: "Our Mumbai to Goa cab service operates 24/7, allowing you to start your journey at any time according to your travel schedule."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All our vehicles are fully air-conditioned, regularly sanitized, and well maintained to provide a comfortable travel experience throughout the journey."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "Velocity Cabs provides flexible one-way, round-trip, and multi-day Mumbai to Goa cab packages to suit every travel requirement."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Choose from sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers for individuals, families, and groups."
  },
  {
    WhyChooseheading: "Trusted Mumbai to Goa Cab Service",
    WhyChoosedescription: "Velocity Cabs is trusted by thousands of travelers for Mumbai to Goa cab bookings due to punctual drivers, clean vehicles, affordable pricing, and professional customer service."
  }
]
};

const faqData = [
  {
    question: "Do you provide Mumbai to Goa cab service?",
    answer: "Yes, Velocity Cabs provides reliable Mumbai to Goa cab service for one-way, round-trip, and customized travel packages."
  },
  {
    question: "How far is Goa from Mumbai?",
    answer: "The distance between Mumbai and Goa is approximately 580 to 600 km, and the journey usually takes around 10 to 12 hours depending on traffic and route conditions."
  },
  {
    question: "Is cab service available 24 hours?",
    answer: "Yes, our Mumbai to Goa cab service is available 24/7 for your convenience."
  },
  {
    question: "Which vehicles are available for this route?",
    answer: "Velocity Cabs offers sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers."
  },
  {
    question: "Can I book a one-way cab?",
    answer: "Yes, we provide both one-way and round-trip cab services from Mumbai to Goa."
  },
  {
    question: "Are vehicles air-conditioned?",
    answer: "Yes, all our vehicles are fully air-conditioned to ensure a comfortable and pleasant journey."
  },
  {
    question: "Can I book the cab online?",
    answer: "Yes, customers can easily book Mumbai to Goa cabs online or by contacting our customer support team."
  },
  {
    question: "Do you provide Goa sightseeing packages?",
    answer: "Yes, we offer customized Goa sightseeing and holiday packages along with Mumbai to Goa cab services."
  },
  {
    question: "Is advance booking recommended?",
    answer: "Yes, advance booking is recommended, especially during weekends, holidays, and the peak tourist season in Goa."
  },
  {
    question: "Are vehicles sanitized regularly?",
    answer: "Yes, all our vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rohan Deshmukh",
    feedback:
      "A memorable road trip from Mumbai to Goa with a very comfortable cab. The vehicle was clean, the drive was smooth, and the long journey felt enjoyable throughout.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Pooja Kulkarni",
    feedback:
      "The Mumbai to Goa cab experience was excellent. The ride was safe, the car was well-maintained, and the entire journey was handled in a very professional way.",
    rating: 5
  }
];




























const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];














const mumbaiGoaJSON = {
  "@context": "https://schema.org",
  "@type": "TouristTrip",
  "name": "Mumbai to Goa Cab | Velocity Cabs",
  "description": "Book a private cab from Mumbai to Goa for outstation travel. AC, Sedan, and SUV taxis available for one-way or round trips with affordable fares.",
  "provider": {
    "@type": "Organization",
    "name": "Velocity Cabs",
    "url": "https://www.velocitycabs.com/"
  },
  "areaServed": {
    "@type": "Place",
    "name": "Mumbai, Maharashtra, India"
  },
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Mumbai to Goa Cab Packages",
    "itemListElement": [
      {
        "@type": "Offer",
        "name": "One Way Cab from Mumbai to Goa",
        "description": "Private cab from Mumbai to Goa for one-way travel with AC/SUV/Sedan options.",
        "url": "https://www.velocitycabs.com/",
        "priceCurrency": "INR",
        "availability": "https://schema.org/InStock"
      },
      {
        "@type": "Offer",
        "name": "Round Trip Mumbai to Goa Cab",
        "description": "Comfortable round-trip cab service from Mumbai to Goa with private AC/SUV/Sedan options.",
        "url": "https://www.velocitycabs.com/",
        "priceCurrency": "INR",
        "availability": "https://schema.org/InStock"
      }
    ]
  }
};



  return (
    <div>
      

<Helmet>
  <title>Mumbai to Goa Cab | Velocity Cabs +91 9136271336</title>
  <meta
    name="description"
    content="Book a private cab from Mumbai to Goa for outstation travel. AC, Sedan, and SUV taxis available for one-way or round trips with affordable fares."
  />
  <script type="application/ld+json">
    {JSON.stringify(mumbaiGoaJSON)}
  </script>
</Helmet>

 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/78.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitogoacab;